import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import style from '../css/AgentDetails.module.css';
import HeaderBarBack from '../components/HeaderBarBack';

const AgentDetails = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [agentData, setAgentData] = useState(null);
	const [loading, setLoading] = useState(true);

	// Fetch agent details
	useEffect(() => {
		if (id) {
			axios
				.get(`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${id}`)
				.then((response) => {
					if (response.data.status) {
						setAgentData(response.data.data);
					} else {
						alert('Error: No agent found or failed to load data.');
					}
				})
				.catch((error) => {
					console.error('Error fetching agent data:', error);
					alert('Error: Failed to fetch agent data.');
				})
				.finally(() => setLoading(false));
		}
	}, [id]);

	// Toggle agent status
	const toggleStatus = () => {
		const newStatus = agentData.status === 'Active' ? 'Inactive' : 'Active';

		axios
			.post('https://hometech-repairs.in/homeTech/UpdateAgentStatus.php', {
				id: agentData.id,
				status: newStatus,
			})
			.then((response) => {
				if (response.data.status) {
					setAgentData({ ...agentData, status: newStatus });
					alert(`Agent status changed to ${newStatus}`);
				} else {
					alert('Error: Failed to update agent status.');
				}
			})
			.catch((error) => {
				console.error('Error updating status:', error);
				alert('Error: An error occurred while updating the status.');
			});
	};

	if (loading) {
		return <div className={style.loader}>Loading...</div>;
	}

	if (!agentData) {
		return <div className={style.error}>No agent details found.</div>;
	}

	return (
		<div className={style.container}>
		<HeaderBarBack title={"Details"} />

			<button
				className={`${style.statusButton} ${
					agentData.status === 'Active' ? style.active : style.inactive
				}`}
				onClick={toggleStatus}
			>
				{agentData.status === 'Active'
					? 'Agent is Active'
					: 'Agent is Inactive'}
			</button>

			<div className={style.details}>
				<p>
					<strong>Name:</strong> {agentData.name}
				</p>
				<p>
					<strong>Phone:</strong> {agentData.phone}
				</p>
				<p>
					<strong>Email:</strong> {agentData.email}
				</p>
				<p>
					<strong>Address:</strong> {agentData.address}
				</p>
				<p>
					<strong>Agent ID:</strong> {agentData.agent_id}
				</p>
				<p>
					<strong>Date of Joining:</strong> {agentData.doj}
				</p>
				<p>
					<strong>Date of Leaving:</strong> {agentData.dol}
				</p>
				<p>
					<strong>Age:</strong> {agentData.age}
				</p>
				<p>
					<strong>Aadhar Number:</strong> {agentData.aadhar}
				</p>
				<p>
					<strong>Emergency Contact:</strong> {agentData.emergency}
				</p>
				<p>
					<strong>Status:</strong> {agentData.status}
				</p>
			</div>
		</div>
	);
};

export default AgentDetails;
